export const LOAD_COGNITO_USER = 'LOAD_COGNITO_USER';
export const LOGOUT_COGNITO_USER = 'LOGOUT_COGNITO_USER';

export const LOAD_PROJECT = 'LOAD_PROJECT';
export const UNLOAD_PROJECT = 'UNLOAD_PROJECT';

export const UPDATE_SHOW_LOGICAL_LANGAGE = 'UPDATE_SHOW_LOGICAL_LANGAGE';
